import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { useTitle } from '../hooks/use-title'
import { connectRequest } from '../site/site'
import { ConnectSiteCard } from '../site/components/connect-site-card'

export const Route = createFileRoute('/_auth/_simple/connect/wordpress')({
    validateSearch: (search) => search as Record<string, unknown>,
    component: ConnectWordPress,
})

function ConnectWordPress() {
    const { t } = useTranslation()
    const search = Route.useSearch()
    const request = connectRequest.safeParse({
        siteUrl: search.site_url,
        siteName: search.site_name,
        redirectUri: search.redirect_uri,
        state: search.state,
        codeChallenge: search.code_challenge,
        codeChallengeMethod: search.code_challenge_method,
    })

    useTitle(t('Connect WordPress website'))

    if (!request.success) {
        return (
            <Result
                status="warning"
                title={t('This connection link is incomplete')}
                subTitle={t('Start connecting again from the Evaa plugin in WordPress.')}
            />
        )
    }

    return <ConnectSiteCard request={request.data} />
}
